import { render } from "./FooterBadgesList.vue?vue&type=template&id=5908820a&scoped=true"
import script from "./FooterBadgesList.vue?vue&type=script&lang=js"
export * from "./FooterBadgesList.vue?vue&type=script&lang=js"

import "./FooterBadgesList.vue?vue&type=style&index=0&id=5908820a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5908820a"]])

export default __exports__